// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3psmO","notes":"Notes_notes__S9wFn","note":"Notes_note__LTCww","markdown":"Notes_markdown__1wm2o"};